<template>
  <v-container fluid>

    <v-window v-model="activeTab">

      <!-- Parents Information -->
      <v-window-item value="father">

        <!-- Alert -->
        <v-alert
            type="info"
            variant="tonal"
            border="start"
            class="mb-6"
        >
          নির্দেশনা : পিতা বা মাতা মৃত হলে তাদের নামের সঙ্গে মৃত লেখা থেকে বিরত
          থাকুন এবং তার পরিবর্তে নির্দিষ্ট স্থানে টিক চিহ্ন প্রদান করুন।
        </v-alert>

        <form @submit.prevent="submitForm">

          <v-row>

            <!-- =========================
                 Father Information
            ========================== -->
            <v-col
                cols="12"
                md="6"
            >

              <div class="section-title mb-4">
                পিতার তথ্য
              </div>

              <!-- Father Dead -->
              <v-checkbox
                  v-model="form.father_dead"
                  label="মৃত"
                  density="comfortable"
                  hide-details
                  class="mb-2"
              />

              <!-- Father NID -->
              <v-text-field
                  v-model="form.father_nid"
                  label="পিতার এনআইডি নম্বর"
                  variant="outlined"
                  density="comfortable"
                  class="mb-3"
              />

              <!-- Father DOB -->
              <v-menu
                  v-model="fatherDobMenu"
                  :close-on-content-click="false"
                  location="bottom"
              >
                <template #activator="{ props }">

                  <v-text-field
                      :model-value="formatDate(form.father_dob)"
                      label="জন্মতারিখ"
                      prepend-inner-icon="mdi-calendar"
                      variant="outlined"
                      density="comfortable"
                      readonly
                      class="mb-3"
                      v-bind="props"
                  />

                </template>

                <v-date-picker style="margin-top: -20px"
                    v-model="form.father_dob"
                    color="primary"
                    hide-header
                    @update:modelValue="fatherDobMenu = false"
                />
              </v-menu>

              <!-- Father Name Bangla -->
              <v-text-field
                  v-model="form.father_name_bn"
                  label="পিতার নাম (বাংলা)"
                  variant="outlined"
                  density="comfortable"
                  class="mb-3"
              />

              <!-- Father Name English -->
              <v-text-field
                  v-model="form.father_name_en"
                  label="পিতার নাম (ইংরেজি)"
                  variant="outlined"
                  density="comfortable"
                  class="mb-3"
              />

              <!-- Father Profession -->
              <v-select
                  v-model="form.father_profession"
                  :items="professions"
                  label="পিতার পেশা"
                  variant="outlined"
                  density="comfortable"
              />

            </v-col>

            <!-- =========================
                 Mother Information
            ========================== -->
            <v-col
                cols="12"
                md="6"
            >

              <div class="section-title mb-4">
                মাতার তথ্য
              </div>

              <!-- Mother Dead -->
              <v-checkbox
                  v-model="form.mother_dead"
                  label="মৃত"
                  density="comfortable"
                  hide-details
                  class="mb-2"
              />

              <!-- Mother NID -->
              <v-text-field
                  v-model="form.mother_nid"
                  label="মাতার এনআইডি নম্বর"
                  variant="outlined"
                  density="comfortable"
                  class="mb-3"
              />

              <!-- Mother DOB -->
              <v-menu
                  v-model="motherDobMenu"
                  :close-on-content-click="false"
                  location="bottom"
              >
                <template #activator="{ props }">

                  <v-text-field
                      :model-value="formatDate(form.mother_dob)"
                      label="জন্মতারিখ"
                      prepend-inner-icon="mdi-calendar"
                      variant="outlined"
                      density="comfortable"
                      readonly
                      class="mb-3"
                      v-bind="props"
                  />

                </template>

                <v-date-picker style="margin-top: -20px"
                    v-model="form.mother_dob"
                    color="primary"
                    hide-header
                    @update:modelValue="motherDobMenu = false"
                />
              </v-menu>

              <!-- Mother Name Bangla -->
              <v-text-field
                  v-model="form.mother_name_bn"
                  label="মাতার নাম (বাংলা)"
                  variant="outlined"
                  density="comfortable"
                  class="mb-3"
              />

              <!-- Mother Name English -->
              <v-text-field
                  v-model="form.mother_name_en"
                  label="মাতার নাম (ইংরেজি)"
                  variant="outlined"
                  density="comfortable"
                  class="mb-3"
              />

              <!-- Mother Profession -->
              <v-select
                  v-model="form.mother_profession"
                  :items="professions"
                  label="মাতার পেশা"
                  variant="outlined"
                  density="comfortable"
              />

            </v-col>

            <!-- =========================
                 Buttons
            ========================== -->
            <v-col
                cols="12"
                class="mt-4 d-flex justify-end"
            >

              <v-btn
                  color="warning"
                  class="me-3 rounded-lg"
                  size="large"
                  variant="flat"
                  @click="resetForm"
              >
                <v-icon start>
                  mdi-refresh
                </v-icon>

                রিসেট করুন
              </v-btn>

              <v-btn
                  color="primary"
                  size="large"
                  class="rounded-lg"
                  type="submit"
              >
                <v-icon start>
                  mdi-content-save-outline
                </v-icon>

                দাখিল করুন
              </v-btn>

            </v-col>

          </v-row>

        </form>

      </v-window-item>

      <!-- Spouse -->
      <v-window-item value="spouse">
        <div class="pa-4 text-grey">
          স্বামী/স্ত্রী তথ্য এখানে যুক্ত হবে
        </div>
      </v-window-item>

      <!-- Guardian -->
      <v-window-item value="guardian">
        <div class="pa-4 text-grey">
          নিকটাত্মীয় তথ্য এখানে যুক্ত হবে
        </div>
      </v-window-item>

    </v-window>

  </v-container>
</template>

<script>
export default {
  name: "ParentsInformationComponent",

  data() {
    return {
      activeTab: "father",

      fatherDobMenu: false,
      motherDobMenu: false,

      professions: [
        "চাকুরিজীবী",
        "ব্যবসায়ী",
        "কৃষক",
        "অবসরপ্রাপ্ত",
        "গৃহিণী",
        "শিক্ষক",
        "ডাক্তার",
        "ইঞ্জিনিয়ার",
      ],

      form: {
        father_dead: false,
        father_nid: "",
        father_dob: "",
        father_name_bn: "",
        father_name_en: "",
        father_profession: null,

        mother_dead: false,
        mother_nid: "",
        mother_dob: "",
        mother_name_bn: "",
        mother_name_en: "",
        mother_profession: null,
      },
    };
  },

  methods: {
    submitForm() {
      console.log("Submitted Data:", this.form);
    },

    resetForm() {
      this.form = {
        father_dead: false,
        father_nid: "",
        father_dob: "",
        father_name_bn: "",
        father_name_en: "",
        father_profession: null,

        mother_dead: false,
        mother_nid: "",
        mother_dob: "",
        mother_name_bn: "",
        mother_name_en: "",
        mother_profession: null,
      };
    },

    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();

      return `${day}-${month}-${year}`;
    },
  },
};
</script>

<style scoped>
.section-title {
  font-size: 18px;
  font-weight: 700;
  color: rgb(var(--v-theme-secondary));
}

.v-tab {
  text-transform: none !important;
  font-size: 14px;
}

.v-window-item {
  animation: fadeSlide 0.35s ease;
}

/* Smooth Animation */
@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>